export const AUTHORIZATION_SERVICE_NAME = 'PODANI_ZR10_ODVOLANI';
